import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { doc, getDoc, updateDoc, getFirestore, serverTimestamp } from 'firebase/firestore';

export default function CandidateNotesTab({ user }) {
  const [userNotes, setUserNotes] = useState('');
  const [isSavingNotes, setIsSavingNotes] = useState(false);

  // Fetch user notes when component mounts
  useEffect(() => {
    if (user && user.id) {
      fetchUserNotes();
    }
  }, [user]);

  const fetchUserNotes = async () => {
    try {
      const db = getFirestore();
      const userProfileRef = doc(db, "user_profiles", user.id);
      const userProfileSnap = await getDoc(userProfileRef);
      
      if (userProfileSnap.exists()) {
        const userData = userProfileSnap.data();
        setUserNotes(userData.adminNotes || '');
      }
    } catch (error) {
      console.error('Error fetching user notes:', error);
    }
  };

  const saveUserNotes = async () => {
    try {
      setIsSavingNotes(true);
      const db = getFirestore();
      const userProfileRef = doc(db, "user_profiles", user.id);
      
      await updateDoc(userProfileRef, {
        adminNotes: userNotes,
        lastUpdated: serverTimestamp()
      });
      
      toast.success('Notes saved successfully');
    } catch (error) {
      console.error('Error saving notes:', error);
      toast.error(`Failed to save notes: ${error.message}`);
    } finally {
      setIsSavingNotes(false);
    }
  };

  if (!user) return null;

  return (
    <div className="bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-4">Admin Notes</h3>
        <div className="mb-4">
          <textarea
            value={userNotes}
            onChange={(e) => setUserNotes(e.target.value)}
            className="w-full h-64 border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
            placeholder="Add notes about this user here..."
          />
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={saveUserNotes}
            disabled={isSavingNotes}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-700 dark:hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            {isSavingNotes ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </>
            ) : 'Save Notes'}
          </button>
        </div>
      </div>
    </div>
  );
} 